import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList, Tooltip } from '@dixa/lib-shared-habla';
import { useCallback, useMemo } from 'react';
import { appActions } from 'app/app.actions';
import { validateIfUserCanMerge } from 'app/views/layout/utils/validateIfUserCanMerge/validateIfUserCanMerge';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
/**
 * Merge contacts action
 *
 * A dropdown menu item that opens the merge contacts modal.
 */
export const MergeContactsAction = ({ user, toggleDropdown, }) => {
    const dispatch = useAppDispatch();
    const canUserMergeValidation = useMemo(() => validateIfUserCanMerge(user), [user]);
    const showMergeContactsModal = useCallback((user) => {
        dispatch(appActions.showModal({
            modal: { type: 'app:mergeContacts', arg: { user } },
        }));
    }, [dispatch]);
    const handleOnItemClick = () => {
        showMergeContactsModal(user);
        toggleDropdown();
    };
    return (_jsx(Tooltip, Object.assign({ content: canUserMergeValidation.reason, disabled: canUserMergeValidation.valid, dark: true, side: "left" }, { children: _jsx(ButtonList.Item, Object.assign({ icon: "combine", onClick: () => handleOnItemClick(), isDisabled: !canUserMergeValidation.valid }, { children: "Merge contact" })) })));
};
